import { MaskConfig } from '../types';

import { useNumberMask } from './useNumberMask';
type Precision = 0 | 2;

const DEFAULT_PRECISION: Precision = 2;

export interface PriceMaskProps {
    /**
     * Текст, добавляющийся в инпуте после числа, обычно это символ валюты ₽, ₺, ₴, $
     */
    currencyText?: string;
    /**
     * Минимальное число, доступное для ввода в input
     * @default 0
     */
    min?: number;
    /**
     * Максимальное число, доступное для ввода в input
     * @default Number.MAX_SAFE_INTEGER
     */
    max?: number;
    /**
     * Количество знаков после запятой
     * @default 2
     */
    precision?: Precision;
}
/**
 * Хук масок цен
 */
export const usePriceMask = (props: PriceMaskProps = {}): MaskConfig => {
    const { currencyText, min = 0, max = Number.MAX_SAFE_INTEGER, precision = DEFAULT_PRECISION } = props;

    return useNumberMask({
        postfix: currencyText ? ` ${currencyText}` : undefined,
        min,
        max,
        precision: precision,
        withThousandSeparator: true,
    });
};
